(function(){
  var body=document.body;
  var nav=document.querySelector('[data-mobile-nav]');
  var open=document.querySelector('[data-nav-open]');
  var close=document.querySelector('[data-nav-close]');
  var shade=document.querySelector('[data-nav-shade]');
  function openNav(){ if(!nav)return; nav.classList.add('is-open'); if(shade)shade.classList.add('is-open'); body.classList.add('nav-open'); }
  function closeNav(){ if(!nav)return; nav.classList.remove('is-open'); if(shade)shade.classList.remove('is-open'); body.classList.remove('nav-open'); }
  if(open) open.addEventListener('click',openNav);
  if(close) close.addEventListener('click',closeNav);
  if(shade) shade.addEventListener('click',closeNav);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeNav(); });

  var header=document.querySelector('[data-site-header]');
  function onScroll(){ if(header) header.classList.toggle('is-scrolled', window.scrollY>16); }
  onScroll(); window.addEventListener('scroll',onScroll,{passive:true});

  var reveals=document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    },{threshold:.12, rootMargin:'0px 0px -40px 0px'});
    reveals.forEach(function(el){io.observe(el);});
  } else { reveals.forEach(function(el){el.classList.add('is-visible');}); }

  document.querySelectorAll('[data-copy-email]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var email=btn.getAttribute('data-copy-email');
      if(navigator.clipboard && email){ navigator.clipboard.writeText(email); btn.textContent='Email copiata'; setTimeout(function(){btn.textContent='Copia email';},1800); }
    });
  });
})();
